import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="steuertransaktion"
export default class extends Controller {
	static targets = ["select", "einkunftsart", "anrechnung", "abschreibungsdauer", "abschreibungsprozent", "manuell"]

	connect() {
		this.updateModus()
	}

	updateModus() {
		// Alle Elemente Hidden machen
		this.hideAllElements()

		switch (this.selectTarget.value) {
			case "anrechnung":
				this.showAnrechnung()
				break
			case "manuell":
				this.showManuell()
				break
			case "linear":
				this.showLinear()
				break
			case "degressiv":
				this.showDegressiv()
				break
			default:
				break
		}
	}

	// Private Methods

	hideAllElements() {
		if (this.hasEinkunftsartTarget) this.einkunftsartTarget.classList.add("hidden")
		if (this.hasAnrechnungTarget) this.anrechnungTarget.classList.add("hidden")
		if (this.hasAbschreibungsdauerTarget) this.abschreibungsdauerTarget.classList.add("hidden")
		if (this.hasAbschreibungsprozentTarget) this.abschreibungsprozentTarget.classList.add("hidden")
		if (this.hasManuellTarget) this.manuellTarget.classList.add("hidden")
	}

	showAnrechnung() {
		if (this.hasEinkunftsartTarget) this.einkunftsartTarget.classList.remove("hidden")
		if (this.hasAnrechnungTarget) this.anrechnungTarget.classList.remove("hidden")
	}

	showManuell() {
		if (this.hasEinkunftsartTarget) this.einkunftsartTarget.classList.remove("hidden")
		if (this.hasManuellTarget) this.manuellTarget.classList.remove("hidden")
	}

	showLinear() {
		if (this.hasEinkunftsartTarget) this.einkunftsartTarget.classList.remove("hidden")
		if (this.hasAnrechnungTarget) this.anrechnungTarget.classList.remove("hidden")
		if (this.hasAbschreibungsdauerTarget) this.abschreibungsdauerTarget.classList.remove("hidden")
	}

	showDegressiv() {
		if (this.hasEinkunftsartTarget) this.einkunftsartTarget.classList.remove("hidden")
		if (this.hasAnrechnungTarget) this.anrechnungTarget.classList.remove("hidden")
		if (this.hasAbschreibungsdauerTarget) this.abschreibungsdauerTarget.classList.remove("hidden")
		if (this.hasAbschreibungsprozentTarget) this.abschreibungsprozentTarget.classList.remove("hidden")
	}
}
